export let unreadCountScreenReaderOnlyText = "Oq8bDc";
export default {unreadCountScreenReaderOnlyText};